import { CreateSalaryDTO } from '@Page/SalaryRun/Modals/CreateSalaryModal/CreateSalaryModal';
import { APIUrls } from '@Util/urls';

export function createSalaryURL(params: CreateSalaryDTO) {
    const apiParams = new URLSearchParams();
    let simplifiedPaymentStateString = '';
    if (params.simplifiedPayment) {
        if (params.regularSalary) {
            simplifiedPaymentStateString += 'REGULAR_SALARY,';
        }
        if (params.travelReports) {
            simplifiedPaymentStateString += 'TRAVEL_REPORTS,';
        }
        if (params.openPosts) {
            simplifiedPaymentStateString += 'RESKONTRO,';
        }
        if (params.employeeExpenses) {
            simplifiedPaymentStateString += 'EXPENSES,';
        }
    } else {
        simplifiedPaymentStateString = 'DEFAULT';
    }

    apiParams.append('year', params.year.toString());
    apiParams.append('month', params.month.toString());
    if (params.description) {
        apiParams.append('description', params.description);
    }
    apiParams.append('date', params.date);
    apiParams.append('specTypesToAdd', simplifiedPaymentStateString);
    if (params.isHistorical) {
        apiParams.append('isHistorical', 'true');
    }
    return APIUrls.SALARY_TRANSACTION + '?' + apiParams.toString();
}
